import { msg } from "@lingui/core/macro";

export const codeRuleMessages = {
	name: msg({ message: "Requires Code" }),
	description: msg({ message: "Restrict registrations to require a code" }),
	errors: {
		notFound: msg({ message: "Code not found" }),
		invalidCode: msg({ message: "Please enter a valid code to register" }),
		limitReached: msg({ message: "Maximum Code Usage Reached. Allowed: {amount}" }),
		vehicleLimitReached: msg({ message: "Vehicle Limit Reached. Allowed: {vehiclesPerCode}" }),
	},
} as const;
